import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  @ViewChild("input_search_text") inputEl: ElementRef;
  database;
  show_sum;

  constructor(public cm:CommonService) { }

  ngOnInit() {
    this.setup_page();
  }

  setup_page(){
    const api = 'getbill';
    this.cm.postHtpp(api,'').then((data:any)=>{
      this.database = data.data;
      this.showProcess = data.data;
    })
  }

  showProcess;
  search(text){
    this.showProcess = [];
    for(var i = 0;i<this.database.length;i++){
      var sameData = 0;
      for (var key in this.database[i]) {
        if(String(this.database[i][key]).match(text)){
            this.showProcess.push(this.database[i]);
            sameData = 1;
        }

        for (var key in this.database[i].attribute) {
          if(String(this.database[i].attribute[key]).match(text) && sameData == 0){
              this.showProcess.push(this.database[i]);
          }
        } 
        sameData = 0;
      } 
    }
    this.showProcess = this.cm.removeDuplicates(this.showProcess,'id');
  }

}
